import { RouteRecordRaw } from 'vue-router';

const companyRoutes: RouteRecordRaw[] = [
  {
    path: '/company/about',
    name: 'company-about',
    component: () => import(/* webpackChunkName: "company-about" */ '@/views/company/AboutView.vue'),
    meta: {
      title: 'About Us',
      requiresAuth: false,
    },
  },
  {
    path: '/company/careers',
    name: 'company-careers',
    component: () => import(/* webpackChunkName: "company-careers" */ '@/views/company/CareersView.vue'),
    meta: {
      title: 'Careers',
      requiresAuth: false,
    },
  },
  {
    path: '/company/contact',
    name: 'company-contact',
    component: () => import(/* webpackChunkName: "company-contact" */ '@/views/company/ContactView.vue'),
    meta: {
      title: 'Contact Us',
      requiresAuth: false,
    },
  },
];

export default companyRoutes;